export const pTON_OP_CODES = {
  TON_TRANSFER: 0x01f3835d,
  DEPLOY_WALLET: 0x4f5f4313,
} as const;
